import React__default from 'react';
import { DEFAULT_GAP } from './constants.mjs';
import useTheme from '../../../../../../node_modules/@mui/material/styles/useTheme.mjs';

// Base layout container. Creates vertical spacing between children items.
const ContentSpacingCore = ({ children, gap })=>{
    const theme = useTheme();
    return /*#__PURE__*/ React__default.createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(gap ?? DEFAULT_GAP)
        }
    }, children);
};

export { ContentSpacingCore };
//# sourceMappingURL=ContentSpacing.mjs.map
